/* istanbul ignore file */
import type {CustomCssVarsFnParams, ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {getBackInStockButtonCustomCssVars} from './BackInStockButton/BackInStockButton.cssVars';
import {getBuyNowButtonCustomCssVars} from './BuyNowButton/BuyNowButton.cssVars';
import {getStickyButtonContainerCustomCssVars} from './StickyButtonContainer/StickyButtonContainer.cssVars';
import {
  getWishlistButtonCustomCssVars,
  getWishlistButtonShouldRenderVars,
} from './WishlistButton/WishlistButton.cssVars';

export const getProductPageButtonContainerCustomCssVars = (customCssVarsFnParams: CustomCssVarsFnParams) => {
  return {
    ...getBackInStockButtonCustomCssVars(customCssVarsFnParams),
    ...getBuyNowButtonCustomCssVars(customCssVarsFnParams),
    ...getWishlistButtonCustomCssVars(customCssVarsFnParams),
    ...getStickyButtonContainerCustomCssVars(customCssVarsFnParams),
  };
};

export const getProductPageButtonContainerShouldRenderVars = (shouldRenderVarsFnParams: ShouldRenderVarsFnParams) => {
  const {booleans} = shouldRenderVarsFnParams;
  const isAddToCartButtonEnabled = booleans.productPage_productAction;
  const isBuyNowButtonEnabled = booleans.productPage_buyNowButtonEnabled;
  const isDynamicPaymentMethodsEnabled = booleans.productPage_dynamicPaymentMethodsEnabled;

  return {
    shouldRenderBuyNowButtonInFirstRow: isBuyNowButtonEnabled && !isAddToCartButtonEnabled,
    shouldRenderCashierButtonWithAddToCartDisabled: !isAddToCartButtonEnabled,
    shouldShowSubscribeInFirstRow: !isAddToCartButtonEnabled,
    shouldShowSubscribeSecondRow: isAddToCartButtonEnabled,
    shouldRenderBuyNowButtonWithDynamicPaymentMethodDisabled: !isDynamicPaymentMethodsEnabled,
    ...getWishlistButtonShouldRenderVars(shouldRenderVarsFnParams),
  };
};
